import { css, styled } from 'styled-components'

export type LayoutContentVariant =
  'compact-hook-page' | 'funnel' | 'subscription'

type LayoutContentProps = {
  $hasBottomContent?: boolean
  $variant?: LayoutContentVariant
}

const getBottomPadding = (base: string, hasBottomContent?: boolean) => {
  if (hasBottomContent) {
    return base
  }
  return `max(${base}, env(safe-area-inset-bottom, 0rem))`
}

export const LayoutContent = styled.div<LayoutContentProps>`
  position: relative;
  z-index: 2;
  display: flex;
  width: 100%;
  max-width: ${({ theme }) => theme.sizes.contentWidth}rem;
  flex: 1;
  flex-direction: column;
  ${({ $hasBottomContent, $variant, theme }) => {
    const horizontalPadding = `${theme.sizes.contentHorizontalPadding}rem`
    switch ($variant) {
      case 'compact-hook-page':
        return css`
          padding: 0 ${horizontalPadding}
            ${getBottomPadding('1rem', $hasBottomContent)};
          gap: 0.5rem;
        `
      case 'subscription':
        return css`
          padding: 1.5rem ${horizontalPadding}
            ${getBottomPadding('1.5rem', $hasBottomContent)};
          gap: 1.5rem;
        `
      case 'funnel':
      default:
        return css`
          padding: ${horizontalPadding} ${horizontalPadding}
            ${getBottomPadding(horizontalPadding, $hasBottomContent)};
          gap: 1rem;
        `
    }
  }};
`
